
import { hakosaloAuth } from '@hakosalo/client-auth';
import CategoryList from '@/components/CategoryList.vue';
import { defineComponent } from 'vue';
export default defineComponent({
	name: "App",
	components: {
		CategoryList,
	},
	data() { return {
		openSidePanel: true as boolean,
		searchText: '' as string,
		categories: [] as any[]
	}},
	methods: {
		sidePanelToggle() {
			this.openSidePanel = !this.openSidePanel;
		},

		toggleOnMobile() {
			if(window.innerWidth < 600) {
				this.openSidePanel = !this.openSidePanel;
			}
		},

		async logout() {
			this.$alert.confirm("Kirjaudutaanko ulos?", "Kirjaudut samalla ulos kaikista muista Hakosalon palveluista. Jatketaanko?", "danger").then(async () => {
				await hakosaloAuth.logoutAsync();
				window.location.reload();
			})
			.catch(() => {
				return
			})
		},

		setCategories(categories: any[]) {
			this.categories = categories;
		}
	}
})
